<template>
  <v-app>
    <component :is="layout">
      <router-view :layout.sync="layout"></router-view>
    </component>

    <v-snackbar
      v-model="$store.state.snackbar.show"
      :color="$store.state.snackbar.color"
      :timeout="2000"
      bottom
    >
      {{ $store.state.snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <loading
      :active.sync="$store.state.isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-app>
</template>

<script>
import Loading from 'vue-loading-overlay'
import eventHub from '@/eventhub'
import store from '@/store/store'
import notificationMixin from './mixins/notificationMixin'
import sessionMixin from './mixins/sessionMixin'

export default {
  name: 'App',
  mixins: [notificationMixin, sessionMixin],
  components: {
    Loading
  },
  computed: {
    layout () {
      return this.$route.meta.layout || this.defaultLayout
    }
  },
  created () {
    eventHub.$on('error_503', () => {
      this.failNotification('Servicio no disponible')
    })

    eventHub.$on('error_401', () => {
      localStorage.clear()
      this.failNotification('La sesión ha vencido')
      this.$router.push({ name: 'Login' })
    })
  },
  data () {
    return {
      defaultLayout: 'full-width-layout',
      fullPage: true
    }
  },
  methods: {
    close () {
      store.commit('closeSnackbar')
    }
  }
}
</script>
